import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Address from '../Partials/Address/Address';
import EntryListPopUp from '../Partials/EntryListPopUp/EntryListPopUp';
import ProgressLine from '../Partials/ProgressLine/ProgressLine';
import MovingFooter from '../Partials/MovingFooter/MovingFooter';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import {
  goToPage,
  setPercent,
  getProducts,
  setIsCheckedUpdateDeliveryAddress,
  setIsSubmit,
  setAddressData,
  setErrorPage,
  setServiceMessageID,
  checkFiberAddressInfraStructure,
  getAddressEntries,
  setSelectedEntry,
  getTechnicianTimeSlots,
  report,
  MovingApartmentExecution,
  setIsTvApp,
  setExtendedFullAddress
} from '../MovingBlockSlice';

const AddressPage = (props) => {
  const [isShowEntriesPopUp, setIsShowEntriesPopUp] = useState(false);
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    props.setPercent(15);
    if (props.movingWithTechnician) {
      gtag4({
        event: 'Moving_Step1_AddressPage',
        title: 'היי ' + props.firstName + ', ' + 'מה הכתובת החדשה אליה נזמין את הטכנאי?',
        step: '1',
        action: 'AddressPage',
        funnel_name: '1 - MovingWithProducts',
      });
      props.report({ actionType: 'New Address', status: 'Ongoing', messageText: 'Address Page Displyed', products: props.products });
    }
    else {
      gtag4({
        event: 'Moving_Step1_AddressPage',
        title: 'מה הכתובת החדשה שלך?',
        step: '1',
        action: 'AddressPage',
        funnel_name: '2 - MovingWithoutProducts',
      });
      props.report({ actionType: 'New Address', status: 'Ongoing', messageText: 'Address Page Displyed', param9: "No technician products" });
    }
  }, []);

  useEffect(() => {
    setExtendedFullAddress();
  }, [props.selectedAddress, props.selectedEntry]);


  function setExtendedFullAddress() {
    if (props.selectedAddress?.cityName) {
      const hasFloor = props.selectedAddress?.floor != '' && props.selectedAddress?.floor != null;
      const hasEntry = props.selectedEntry?.entry != '' && props.selectedEntry?.entry != null;

      let fullAddress =
        props.selectedAddress?.streetName + ' ' +
        props.selectedAddress?.home + '/' +
        props.selectedAddress?.apartment + ', ' +
        (hasFloor ? ("קומה: " + props.selectedAddress?.floor + ", ") : "") +
        (hasEntry ? ("כניסה: " + props.selectedEntry?.entry + ", ") : "") +
        props.selectedAddress?.cityName;
      props.setExtendedFullAddress(fullAddress);
    }
  }


  const handlePageValidate = async (data) => {
    props.setIsSubmit(false);
    data.fullAddress = data.selectedAddress?.streetName + ' ' + data.selectedAddress?.home + '/' + data.selectedAddress?.apartment + ', ' + data.selectedAddress?.cityName;
    props.report({ actionType: "New Address", status: "Ongoing", messageText: "Address Page Button Clicked", products: props.products, param2: data.fullAddress, })

    if (data.isValid) {
      //אישור טופס
      data.fullAddress =
        data.selectedAddress?.streetName +
        ' ' +
        data.selectedAddress?.home +
        '/' +
        data.selectedAddress?.apartment +
        ', ' +
        data.selectedAddress?.cityName;
      props.setAddressData(data);
      getAddressEntries();
    }
  };
  async function handleNextPage() {
    if (!props.movingWithTechnician) {
      if (props.products.find((x) => x.technician)) {
        props.goToPage('productsPage');
        return;
      }
      if (props.isCheckedUpdateDeliveryAddress) {
        props.goToPage('summaryPage');
        return;
      }
      else {
        const hasTvApp = props.products.find((x) => x.productType.toUpperCase() == 'TV' && x.equipment == false);
        if (hasTvApp) {
          props.setIsTvApp(true);
          const response = await props.MovingApartmentExecution();
          if (response.payload.Body.isSuccess) {
            props.report({ actionType: "No Adress Update Page", status: "Completed", messageText: "No Adress Update Page Displayed", products: props.products, param2: props.fullAddress, param4: props.selectedEntry?.infrastructure })
            props.setServiceMessageID('TECHNICIAN_UPDATE_NOT_NEEDED_TV_APP');
            props.goToPage("serviceMessagesPage");
          }
        }
        else {
          props.report({ actionType: "No Adress Update Page", status: "Completed", messageText: "No Adress Update Page Displayed", products: props.products, param2: props.fullAddress, param4: props.selectedEntry?.infrastructure })
          gtag4({
            event: 'Moving_Step3_NoAddressOrProductToUpdatePage',
            title: "השירותים שברשותך לא דורשים טכנאי",
            step: '3',
            action: 'NoAddressOrProductToUpdatePage',
            funnel_name: '1 - MovingWithProducts',
          });
          props.setServiceMessageID('TECHNICIAN_UPDATE_NOT_NEEDED_WITH_MAIL');
          props.goToPage("serviceMessagesPage");
        }
      }
    } else {
      props.goToPage('productsPage');
    }
  };

  async function getAddressEntries(){
    const response = await props.getAddressEntries();
    const entryList = response.payload?.Body?.entryList;
    if (entryList != undefined && entryList?.length > 0) {
      setEntries(entryList);
      if (entryList.length == 1) {
        setSelectedEntry(entryList[0]);
        getFiberAddressInfraStructure();
      } else {
        setEntries(entryList);
        setIsShowEntriesPopUp(true);
      }
    }
    else{
      handleNextPage();
    }
  }


  async function getFiberAddressInfraStructure() {
    const response = await props.checkFiberAddressInfraStructure();
    if (response.payload != undefined) {
      const entryList = response.payload?.Body?.entryList;
      if (entryList?.length > 0) {
        const selected_entry = entryList.length == 1 ? entryList[0] :  entryList.find(x => x.entry == props.selectedEntry.entry);
        setSelectedEntry(selected_entry);
        handleNextPage();
      } else {
        handleNextPage();
      }
    }
  }
  function closeEntriesPopUp() {
    setIsShowEntriesPopUp(false);
  }
  function setSelectedEntry(entry) {
    props.setSelectedEntry(entry);
  }
  function handlePopUpEntriesBtnClick() {
    //handleNextPage();
    getFiberAddressInfraStructure()
  }
  function handleBtnClick() {
    if (!props.movingWithTechnician) {
      gtag4({
        event: 'Moving_Step1_AddressPageContinueButton',
        title: 'מה הכתובת החדשה שלך?',
        button: 'המשך',
        step: '1',
        action: 'AddressPageContinueButton',
        funnel_name: '2 - MovingWithoutProducts',
      });
    }

    props.setIsSubmit(true);
    props.report({
      actionType: 'New Address',
      status: 'Ongoing',
      messageText: 'Address Page Button Clicked',
      products: props.products,
      param2: props.address?.selectedAddress?.fullAddress,
    });
    gtag4({
      event: 'Moving_Step1_AddressPageContinueButton',
      title: 'היי ' + props.firstName + ', ' + 'מה הכתובת החדשה שאליה יגיע הטכנאי?',
      button: 'המשך',
      step: '1',
      action: 'Moving_Step1_2_AddressPageContinueButton',
      funnel_name: '1 - MovingWithProducts',
    });
  }

  function handleMailingAddressChanged(checkbox) {
    props.setIsCheckedUpdateDeliveryAddress(checkbox);
  }

  return (
    <>
      <ProgressLine percent={props.percent} />

      <Address
        firstName={props.firstName}
        isCheckedUpdateDeliveryAddress={props.isCheckedUpdateDeliveryAddress}
        onMailingAddressChanged={handleMailingAddressChanged}
        handlePageValidate={handlePageValidate}
        isSubmit={props.isSubmit}
        isReqTechnician={props.movingWithTechnician}
      />

      <EntryListPopUp
        showPopUp={isShowEntriesPopUp}
        onClose={() => closeEntriesPopUp(false)}
        firstName={props.firstName}
        onBtnClick={handlePopUpEntriesBtnClick}
        entries={entries}
        setSelectedEntry={setSelectedEntry}
        selectedEntry={props.selectedEntry}
      />

      <MovingFooter onBtnClick={handleBtnClick} btnText={'המשך'} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.movingBlock.movingApartmentData.page,
    percent: state.movingBlock.movingApartmentData.percent,
    products: state.movingBlock.movingApartmentData.products,
    movingWithTechnician: state.movingBlock.movingApartmentData.movingWithTechnician,
    isSubmit: state.movingBlock.movingApartmentData.isSubmit,
    isCollaborationApproval: state.movingBlock.movingApartmentData.isCollaborationApproval,
    isCheckedUpdateDeliveryAddress: state.movingBlock.movingApartmentData.isCheckedUpdateDeliveryAddress,
    selectedEntry: state.movingBlock.movingApartmentData.address?.selectedEntry,
    firstName: state.authentication.loginData.userDetails.firstName,
    fullAddress: state.movingBlock.movingApartmentData.address?.fullAddress,
    selectedAddress: state.movingBlock.movingApartmentData.address.selectedAddress
  };
};

const mapDispatchToProps = {
  goToPage,
  setPercent,
  getProducts,
  setIsCheckedUpdateDeliveryAddress,
  setIsSubmit,
  setAddressData,
  setErrorPage,
  setServiceMessageID,
  checkFiberAddressInfraStructure,
  getAddressEntries,
  setSelectedEntry,
  getTechnicianTimeSlots,
  report,
  MovingApartmentExecution,
  setIsTvApp,
  setExtendedFullAddress
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressPage);
